export default __webpack_public_path__ + "static/media/Edge-scorn Sabatons.e00c88a8.jpg";